'use client';

import Image from 'next/image';
import { useState } from 'react';
import MediaDialog from './media-dialog';

const MediaList = () => {
  const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<{
    items: {
      src: string;
      mobileSrc: string;
      alt: string;
      width: number;
      height: number;
      mobileWidth: number;
      mobileHeight: number;
    }[];
    curIndex: number;
  }>({
    items: [],
    curIndex: 0,
  });

  return (
    <>
      <ul className='mx-auto mt-10 grid max-w-site grid-cols-2 gap-x-[23px] gap-y-5 px-4 lg_mt-[100px] lg_flex lg_flex-wrap lg_gap-x-[53px] lg_gap-y-[60px] lg_px-0'>
        {configs.map(({ src, mobileSrc, alt, media }, i) => {
          return (
            <li
              key={i}
              className='flex basis-[160px] flex-col items-center justify-center gap-y-[5px] lg_basis-[320px] lg_gap-y-2.5'
            >
              <Image
                src={mobileSrc}
                className='block cursor-pointer lg_hidden'
                alt={alt}
                width={140}
                height={60}
                unoptimized
                onClick={() => {
                  if (!media) {
                    return;
                  }

                  setMediaDialogOpen(true);
                  setPreviewImages({
                    items: media,
                    curIndex: 0,
                  });
                }}
              />
              <Image
                src={src}
                className='hidden cursor-pointer lg_block'
                alt={alt}
                width={260}
                height={100}
                unoptimized
                onClick={() => {
                  if (!media) {
                    return;
                  }

                  setMediaDialogOpen(true);
                  setPreviewImages({
                    items: media,
                    curIndex: 0,
                  });
                }}
              />
              <button
                type='button'
                className='text-[15px] leading-5 text-80583F underline'
                onClick={() => {
                  if (!media) {
                    return;
                  }

                  setMediaDialogOpen(true);
                  setPreviewImages({
                    items: media,
                    curIndex: 0,
                  });
                }}
              >
                Learn More
              </button>
            </li>
          );
        })}
      </ul>
      <MediaDialog
        open={mediaDialogOpen}
        onOpenChange={setMediaDialogOpen}
        previewImages={previewImages}
        setPreviewImages={setPreviewImages}
      />
    </>
  );
};

const configs = [
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-m.png`,
    alt: 'the knot',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "the knot" recommends AW Adah Wedding Dress on the website.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-2.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-m-2.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "the knot" recommends several AW.Bridal bridesmaid dresses.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-3.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/the-knot-media-m-3.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "the knot" introduces "15 Vintage Style Wedding Dresses Trending for 2025", featuring AW.Bridal Adah Wedding Dress.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-m.png`,
    alt: 'BRIDES',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "Brides" highlights Best Knee-Length dress is AW Trista Bridesmaid Dress in Biscotti, featuring introduce the dress.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-2.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-m-2.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "Brides" introduces Best Affordable dress as AW Romula Dress.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-3.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/brides-media-m-3.png`,
        mobileWidth: 258,
        mobileHeight: 230,
        alt: 'The article "The 14 Best Bridesmaid Pajama Sets for a Cute, Cohesive Getting-Ready Look" by the media "Brides", tells one of best.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes-m.png`,
    alt: 'green-wedding-shoes',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The article "Embrace the Blooms: The Timeless Allure of Floral Wedding Dresses" by the media "green wedding shoes" mentions AW.Bridal floral dress.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes-media-2.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/green-wedding-shoes-media-m-2.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The article "Stunning Satin Bridesmaids Dresses: 9 Lovely Looks from AW.Bridal" by the media "green wedding shoes" introduces 9 different dresses of AW.Bridal.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/junebug-weddings.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/junebug-weddings-m.png`,
    alt: 'junebug-weddings',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/junebug-weddings-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/junebug-weddings-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "junebug wedding" recommends AW.Bridal Adalia Dress.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward-m.png`,
    alt: 'WEDDING FORWARD',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "wedding forward" recommends Metallic Burgundy Bridesmaid Dress of AW.Bridal.',
      },
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward-media-2.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-forward-media-m-2.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "wedding forward" recommends the brand AW.Bridal.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-chicks.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-chicks-m.png`,
    alt: 'WEDDING CHICKS',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-chicks-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/wedding-chicks-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The article "AW Bridal Has Floral Dresses For Every Season-Here Are Our Faves" by the media "Wedding Chicks" introduces AW.Bridal floral dresses.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/real-simple.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/real-simple-m.png`,
    alt: 'real-simple',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/real-simple-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/real-simple-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "Real Simple" introduces the brand AW.Bridal.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/bm.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/bm-m.png`,
    alt: 'BM',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/bm-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/bm-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The media "BM" introduces the brand AW.Bridal.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/boho-wedding.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/boho-wedding-m.png`,
    alt: 'BOHO WEDDING',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/boho-wedding-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/boho-wedding-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The article "Bridal Style: Fabulous Floral Dresses From AW Bridal" by the media "Boho weddings" introduces AW.Bridal.',
      },
    ],
  },
  {
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/100-layer-cake.png`,
    mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/100-layer-cake-m.png`,
    alt: '100 Layer Cake',
    media: [
      {
        src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/100-layer-cake-media-1.png`,
        width: 800,
        height: 496,
        mobileSrc: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/about-us/media/100-layer-cake-media-m-1.png`,
        mobileWidth: 280,
        mobileHeight: 250,
        alt: 'The article "Spring floral dresses with AW Bridal + 20% off" by the media "100 Layer Cake" introduces AW.Bridal floral dresses.',
      },
    ],
  },
];

export default MediaList;
